import React from 'react'
import { Field, FieldProps } from 'formik'
import { FormLabelProps } from '@material-ui/core/FormLabel'

import { CheckboxLabel, Checkbox } from './styled'
import { CheckboxProps } from '@material-ui/core/Checkbox'

interface CheckboxFieldProps extends FormLabelProps {
  name: string
  label?: React.ReactNode
  CheckboxProps: CheckboxProps
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({ name, label, CheckboxProps }) => (
  <Field name={name}>
    {({ field }: FieldProps<boolean>) => (
      <CheckboxLabel control={<Checkbox checked={field.value} {...field} {...CheckboxProps} />} label={label} />
    )}
  </Field>
)

export default CheckboxField
